import { render, staticRenderFns } from "./TableTem.vue?vue&type=template&id=a973339c&scoped=true"
import script from "./TableTem.vue?vue&type=script&lang=js"
export * from "./TableTem.vue?vue&type=script&lang=js"
import style0 from "./TableTem.vue?vue&type=style&index=0&id=a973339c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a973339c",
  null
  
)

export default component.exports